import React from "react";
import {
  LocationStateType, useLastNotifiedLocation,
  useLocation
} from "./hooks";

type MapLocationStateToPropsType = (state: LocationStateType) => any;

export const withLocation = (
  mapLocationStateToProps?: MapLocationStateToPropsType,
) => (BaseComponent: React.Component) => (props: any) => {
  const locationState = useLocation();
  return (
    // @ts-ignore
    <BaseComponent
      {...props}
      {...(mapLocationStateToProps ? mapLocationStateToProps(locationState) : {})}
    />
  )
}

export const withLastNotifiedLocation = (
  mapLastNotifiedLocationStateToProps?: MapLocationStateToPropsType,
) => (BaseComponent: React.Component) => (props: any) => {
  const locationState = useLastNotifiedLocation();
  return (
    // @ts-ignore
    <BaseComponent
      {...props}
      {...(mapLastNotifiedLocationStateToProps ? mapLastNotifiedLocationStateToProps(locationState) : {})}
    />
  )
}

